import { render } from "./AccountHelpSearch.vue?vue&type=template&id=2448270f&scoped=true"
import script from "./AccountHelpSearch.vue?vue&type=script&lang=js"
export * from "./AccountHelpSearch.vue?vue&type=script&lang=js"

import "./AccountHelpSearch.vue?vue&type=style&index=0&id=2448270f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2448270f"]])

export default __exports__